import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Button } from '../../../components/button'
import { AssignmentButtonWrapper, TableWrapper } from '../../../styles/assignment/assignment';
import { Table } from '../../../components/table/table';
import { AdminSystemSettingsData } from '../../../services/tableData';
import { DeleteInstructorContainer } from '../../../styles/instructors/instructors';
import { CustomModal } from '../../../components/modal'
import { useState } from 'react';
import { SupportTicket } from '../../../components/support-ticket/support-ticket';
// import { RowDots } from "../../../components/table/row-menu";


const AdminSupport = ({ history }) => {
    const [showModal, setShowModal] = useState(false);
    return (
        <>
            <CustomModal onClose={() => setShowModal(false)} showModal={showModal}>
                <DeleteInstructorContainer>
                    <p className='title'>Level Elevation</p>
                    <p className='sub-title'>Please confirm that you will like to close this Term and move to the next Term</p>

                    <div className="button-container">
                        <Button size='small'>CONFIRM</Button>
                        <Button onClick={() => setShowModal(false)} size='small' variant="secondary">CANCEL</Button>
                    </div>

                </DeleteInstructorContainer>
            </CustomModal>
            <DashboardWrapper>
                <MainContentWrapper fullHeight>
                    <Container>
                        <MainContent>
                            <Heading>
                                Extra/Support
                            </Heading>
                            <Breadcrumb
                                crumbs={['Extra/Support']}
                            />
                            <div style={{ marginTop: '2.9rem' }}>
                                <AssignmentButtonWrapper>
                                    <Button variant="secondary" size="small" onClick={() => history.push('/admin/support/make-announcement')}>MAKE ANNOUNCEMENT</Button>
                                </AssignmentButtonWrapper>
                            </div>
                            <SupportTicket category="open" />
                            <SupportTicket category="closed" />
                        </MainContent>
                    </Container>
                </MainContentWrapper>
            </DashboardWrapper >
        </>
    )
}

export default AdminSupport
